<template>
  <div class="detail-main">
    <Header ref="header"/>
    <div class="main-1200-width padding-bottom-40 article_box">
      <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/News' }">最新消息</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content" v-html="detail.content"></div>
      <div v-if="!detail" class="no-data"><img src="@/assets/no_data.png" alt=""></div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from "@/globalComponents/Header";
import Footer from "@/globalComponents/Footer";
import dataApi from '@/api/data'
export default {
  data() {
    return {
      id    : 0,
      title : '',
      detail: {}
    };
  },
  created() {
    console.log(this.$route);
    this.id = this.$route.params.id;
    this.getData();
  },
  methods   : {
    async getData() { //获取页面数据
      let that = this;
      let {data} = await dataApi.richtext({id: that.id})
      this.detail = data;
      this.title = data.title
    },
  },
  components: {
    Header,
    Footer
  }
};
</script>
<style lang="less" scoped>
@import url("detail.less");
</style>
